module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Styles-35476b9d9fad98239f4761e54c456c66.svg";